import { Cable, ClipboardList, Package, Search } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui'

import { EmptyState } from './empty-state'

type PresetProps = {
  title?: string
  description?: string
  action?: ReactNode
  className?: string
  children?: ReactNode
  actionLabel?: string
  onAction?: () => void
}

/** Empty states amigáveis padronizados (Sprint T1). */
export function EmptyProducts({
  title = 'Sem produtos',
  description = 'Nenhum produto para exibir agora. Ajuste os filtros ou monte uma configuração no Sales Workbench.',
  ...rest
}: PresetProps) {
  return <EmptyState icon={Package} title={title} description={description} {...rest} />
}

export function EmptySearch({
  title = 'Sem pesquisa',
  description = 'Digite um termo e pesquise nos fornecedores conectados. Resultados aparecerão aqui.',
  ...rest
}: PresetProps) {
  return <EmptyState icon={Search} title={title} description={description} {...rest} />
}

export function EmptyBudget({
  title = 'Sem orçamento',
  description = 'Informe o cliente e o pedido à esquerda e clique em Gerar orçamento para ver o resumo completo.',
  action,
  ...rest
}: PresetProps) {
  return (
    <EmptyState
      icon={ClipboardList}
      title={title}
      description={description}
      action={
        action !== undefined
          ? action
          : (
              <Button asChild className="mt-1">
                <Link to="/sales-workbench">Abrir Sales Workbench</Link>
              </Button>
            )
      }
      {...rest}
    />
  )
}

export function EmptyIntegrations({
  title = 'Sem integrações',
  description = 'Nenhuma integração configurada. Conecte um fornecedor no Integration Center para habilitar pesquisas.',
  action,
  ...rest
}: PresetProps) {
  return (
    <EmptyState
      icon={Cable}
      title={title}
      description={description}
      action={
        action !== undefined
          ? action
          : (
              <Button asChild variant="outline" className="mt-1">
                <Link to="/integrations">Abrir Integrações</Link>
              </Button>
            )
      }
      {...rest}
    />
  )
}
